/** Autogenerated by public2business schematic. DO NOT CHANGE! */
/* tslint:disable */
export * from './badge/badge.component';
export * from './badge.module';
